document.addEventListener('DOMContentLoaded', function () {

      $(".sm2026-bigproduct-cards").addClass("active");

     window.VWO = window.VWO || [];
	  VWO.event = VWO.event || function () {VWO.push(['event'].concat([].slice.call(arguments)))}; 


    var sm2026BigproductCartSubmitting = false;

    function buildSm2026MarathonGiftItem(giftVariantId, giftHandle, mainVariantId) {
      return {
        id: giftVariantId,
        quantity: 1,
        properties: {
          _warranty_main_variant_id: String(mainVariantId),
          _benefit_linked: 'true',
          _benefit_handle: String(giftHandle || 'tcs-sydney-marathon-cowbell'),
          _bundle_item_type: 'marathon_gift',
          _bundle_locked: 'true',
        },
      };
    }

    function openSm2026CartDrawer() {
      if (window.timber && window.timber.RightDrawer && typeof window.timber.RightDrawer.open === 'function') {
        window.timber.RightDrawer.open();
      } else if (window.ajaxCart && typeof window.ajaxCart.itemAddedCallback === 'function') {
        window.ajaxCart.itemAddedCallback();
      }
    }

    function reportSm2026CartError(error) {
      console.error('Marathon bigproduct add to cart failed:', error);
    }

    function sm2026ParseMoneyAmount(text) {
      if (!text) return 0;
      return Number(String(text).replace(/[^0-9.]/g, '')) || 0;
    }

    function sm2026GetCardListIndex($item) {
      if (!$item || !$item.length) return 1;
      var className = $item.attr('class') || '';
      var match = className.match(/\bitem-(\d+)\b/);
      if (match) return Number(match[1]);
      var $cards = $item.closest('.sm2026-bigproduct-cards');
      if ($cards.length) {
        return $item.index($cards.find('.item')) + 1;
      }
      return 1;
    }

    function sm2026GetItemListId($item, productItem) {
      var fromData = productItem && productItem[4] ? productItem[4] : '';
      if ($item && $item.length) {
        var $section = $item.closest('[data-ga-item-list]');
        if ($section.length) {
          return $section.attr('data-ga-item-list') || fromData || 'top_sales';
        }
      }
      return fromData || 'top_sales';
    }

    function sm2026GetActiveColorItem($item) {
      if (!$item || !$item.length) return $();
      var $active = $item.find('.color_list .variant-item.active').filter(':visible');
      if (!$active.length) {
        $active = $item.find('.color_list .variant-item.active');
      }
      return $active.first();
    }

    function sm2026GetCardDiscount($item, price) {
      var $activeVariant = sm2026GetActiveColorItem($item);
      if ($activeVariant.length) {
        var priceCents = Number($activeVariant.attr('data-price'));
        var compareCents = Number($activeVariant.attr('data-compprice'));
        if (Number.isFinite(priceCents) && Number.isFinite(compareCents) && compareCents > priceCents) {
          return +((compareCents - priceCents) / 100).toFixed(2);
        }
      }

      if ($item && $item.length && Number.isFinite(price)) {
        var compareText = $item
          .find('.price.active .tag_sale-compare-price')
          .first()
          .text();
        var comparePrice = sm2026ParseMoneyAmount(compareText);
        if (comparePrice > price) {
          return +(comparePrice - price).toFixed(2);
        }
      }

      return 0;
    }

    $(document).on('click', '.sm2026-bigproduct-cards .item .variant-wrapper button[type="submit"]', function () {
      var $button = $(this);
      if ($button.hasClass('disable') || $button.is(':disabled')) return;

      var $item = $button.closest('.item');
      var $wrapper = $button.closest('.variant-wrapper');
      var productData =
        $wrapper.find('.product-data-div').attr('data-product-data') || getSm2026ActiveProductData($item);

      if (!productData) return;

      page_product_ga4_deal(productData.split('::'), $button.text().trim(), 'add_to_cart', $item);
    });

    $(".sm2026-bigproduct-cards .add-to-cart-form2").on('submit', function (evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();

      if (sm2026BigproductCartSubmitting) {
        return;
      }

      var $form = $(this);

      var $submitButton = $form.find('button[type="submit"]');
      if (!$submitButton.length || $submitButton.hasClass('disable') || $submitButton.is(':disabled')) {
        return;
      }

      var $item = $form.closest('.item');

      var giftCartApi = window.opendotsGiftCart;
      var giftVariantId = Number($item.attr('data-sm2026-gift-variant-id'));
      var giftHandle = $item.attr('data-sm2026-gift-handle') || 'tcs-sydney-marathon-cowbell';
      var giftEnabled = $item.attr('data-sm2026-gift-enabled') === 'true';
      var mainVariantId = Number($form.find('input[name="id"]').val());

      if (!giftCartApi || !giftEnabled || !Number.isFinite(giftVariantId) || giftVariantId <= 0 || !Number.isFinite(mainVariantId) || mainVariantId <= 0) {
        ShopifyAPI.addItemFromForm2(evt.target, ajaxCart.itemAddedCallback, ajaxCart.itemErrorCallback);
        return;
      }

      var giftItems = [buildSm2026MarathonGiftItem(giftVariantId, giftHandle, mainVariantId)];
      sm2026BigproductCartSubmitting = true;

      var submitTask = function () {
        return giftCartApi.addBundle(
          {
            mainItem: { id: mainVariantId, quantity: 1 },
            giftItems: giftItems,
            form: evt.target,
          },
          { skipLegacyGiftSync: true }
        );
      };

      var request = typeof giftCartApi.enqueue === 'function' ? giftCartApi.enqueue(submitTask) : submitTask();

      request
        .then(function () {
          openSm2026CartDrawer();
        })
        .catch(function (error) {
          reportSm2026CartError(error);
        })
        .finally(function () {
          sm2026BigproductCartSubmitting = false;
        });
    });

    function preloadSm2026VariantImages(root) {
      var scope = root || document;
      scope.querySelectorAll('.sm2026-bigproduct-cards .variant-img').forEach(function (img) {
        if (img.dataset.src && !img.getAttribute('src')) {
          img.setAttribute('src', img.dataset.src);
        }
        img.loading = 'eager';
        if (img.getAttribute('src')) {
          var preloader = new Image();
          preloader.src = img.getAttribute('src');
        }
      });
    }

    function activateSm2026VariantImage(vindex, pid, $scope) {
      var $container = $scope && $scope.length ? $scope : $('.sm2026-bigproduct-cards');
      var $imgs = $container.find('.variant-img[data-index="' + vindex + '"][data-pid="' + pid + '"]');
      var img = $imgs[0];
      if (img) {
        if (img.dataset.src && !img.getAttribute('src')) {
          img.setAttribute('src', img.dataset.src);
        }
        img.loading = 'eager';
        if (!img.complete) {
          img.addEventListener(
            'load',
            function onVariantImageLoad() {
              img.removeEventListener('load', onVariantImageLoad);
              $imgs.addClass('active').siblings('.variant-img').removeClass('active');
            },
            { once: true }
          );
          img.addEventListener(
            'error',
            function onVariantImageError() {
              img.removeEventListener('error', onVariantImageError);
              $imgs.addClass('active').siblings('.variant-img').removeClass('active');
            },
            { once: true }
          );
          return;
        }
      }
      $imgs.addClass('active').siblings('.variant-img').removeClass('active');
    }

    function updateSm2026VariantPrice($item) {
      if (!$item || !$item.length) return;

      var $activeVariant = $item.find('.color_list .variant-item.active').filter(':visible');
      if (!$activeVariant.length) {
        $activeVariant = $item.find('.color_list .variant-item.active').first();
      }
      if (!$activeVariant.length) return;

      var vindex = $activeVariant.attr('data-index');
      var pid = $activeVariant.attr('data-pid');

      $item
        .find('.price-wrapper .price[data-index="' + vindex + '"][data-pid="' + pid + '"]')
        .addClass('active')
        .siblings('.price')
        .removeClass('active');
    }

    function isSm2026BlackVariant($variantItem) {
      if (!$variantItem || !$variantItem.length) return false;

      var tag = String($variantItem.attr('data-tag') || '').toLowerCase();
      var option1 = String($variantItem.attr('data-option1') || '').toLowerCase();

      return tag.indexOf('black') !== -1 || option1.indexOf('black') !== -1;
    }

    function updateSm2026GiftImage($item) {
      if (!$item || !$item.length) return;

      var $activeVariant = $item.find('.color_list .variant-item.active').filter(':visible');
      if (!$activeVariant.length) {
        $activeVariant = $item.find('.color_list .variant-item.active').first();
      }
      if (!$activeVariant.length) return;

      var defaultPc = $item.attr('data-sm2026-gift-pc') || '';
      var defaultMb = $item.attr('data-sm2026-gift-mb') || '';
      var blackPc = $item.attr('data-sm2026-gift-black-pc') || '';
      var blackMb = $item.attr('data-sm2026-gift-black-mb') || '';
      var useBlack = isSm2026BlackVariant($activeVariant) && blackPc && blackMb;
      var pcUrl = useBlack ? blackPc : defaultPc;
      var mbUrl = useBlack ? blackMb : defaultMb;

      if (!pcUrl && !mbUrl) return;

      $item.find('.sm2026-gift-bar__image-picture').each(function () {
        var $picture = $(this);
        if (mbUrl) {
          $picture.find('.sm2026-gift-bar__image-source-mb').attr('srcset', mbUrl);
        }
        if (pcUrl) {
          $picture.find('.sm2026-gift-bar__image-img').attr('src', pcUrl);
        }
      });
    }

    preloadSm2026VariantImages();

    $(".sm2026-bigproduct-cards .item .color_list .variant-item").on('mouseenter', function () {
      var vindex = $(this).attr('data-index');
      var pid = $(this).attr('data-pid');
      var img = document.querySelector(
        '.sm2026-bigproduct-cards .variant-img[data-index="' + vindex + '"][data-pid="' + pid + '"]'
      );
      if (img && img.getAttribute('src')) {
        var preloader = new Image();
        preloader.src = img.getAttribute('src');
      }
    });

    $(".sm2026-bigproduct-cards .item .color_list .variant-item").click(function(){
      const productId = $(this).attr('data-pid');
      const variantId = $(this).attr('data-var_id');
      var vid = $(this).attr("data-id");
      var vindex= $(this).attr("data-index");
      var pid = $(this).attr("data-pid");
      $(this).addClass("active").siblings().removeClass("active");
      $(".sm2026-bigproduct-cards .variant-wrapper[data-id="+vid+"]").addClass("active").siblings().removeClass("active");
      var $item = $(this).closest('.item');
      activateSm2026VariantImage(vindex, pid, $item);
      updateSm2026VariantPrice($item);
      updateSm2026GiftImage($item);
    });

    var OPENRUN_PRO2_MINI_IDS = {
      '41843066765360': true,
      '41628610396208': true,
      '41628610363440': true
    };

    function isOpenrunPro2MiniVariant($colorItem) {
      var id = String($colorItem.attr('data-var_id') || $colorItem.attr('data-id') || '');
      if (OPENRUN_PRO2_MINI_IDS[id]) return true;
      if ($colorItem.attr('data-option-size') === 'Mini') return true;
      var sku = String($colorItem.attr('data-sku') || '').toUpperCase();
      if (sku.indexOf('-MN-') !== -1 || sku.indexOf('S821-MN') !== -1) return true;
      return false;
    }

    function getSm2026ActivePort($item) {
      var $portItem = $item.find(
        '.charger-port-items-wrapper .toggle-product-option-item.active, .charger-port-items-wrapper .connectivity_switch.active'
      );
      if (!$portItem.length) {
        return '';
      }
      return $portItem.attr('data-option-port') || $portItem.attr('data-tag') || $portItem.attr('data-option-size') || '';
    }

    function applySm2026VariantVisibility($item, triggerClick) {
      var $sizeToggle = $item.find('.toggle-product-size .toggle-product-size-item.active');
      var size = 'Standard';
      if ($sizeToggle.length) {
        size = getSm2026ToggleSize($sizeToggle);
      }

      var port = getSm2026ActivePort($item);
      var $colorItems = $item.find('.color_list .variant-item');
      var isOpenrunPro2 = $item.hasClass('openrun-pro2');
      var hasSizeToggle = $item.hasClass('has-size-toggle') && $item.find('.toggle-product-size').length > 0;
      var hasPortToggle =
        $item.find(
          '.charger-port-items-wrapper .toggle-product-option-item, .charger-port-items-wrapper .connectivity_switch'
        ).length > 1;

      if (!hasSizeToggle && !hasPortToggle) {
        return;
      }

      $colorItems.css('display', 'none');

      $colorItems.each(function () {
        var $colorItem = $(this);
        var matchSize;
        if (isOpenrunPro2) {
          matchSize = size === 'Mini' ? isOpenrunPro2MiniVariant($colorItem) : !isOpenrunPro2MiniVariant($colorItem);
        } else {
          matchSize = !hasSizeToggle || $colorItem.attr('data-option-size') === size;
        }
        var matchPort = !hasPortToggle || !port || $colorItem.attr('data-option-port') === port;
        if (matchSize && matchPort) {
          $colorItem.css('display', 'flex');
        }
      });

      if (triggerClick === false) {
        return;
      }

      var $visible = $colorItems.filter(function () {
        return $(this).css('display') === 'flex';
      });

      var preferredId = $sizeToggle.attr('data-var_id');
      var $preferred = preferredId
        ? $visible.filter('[data-var_id="' + preferredId + '"], [data-id="' + preferredId + '"]')
        : $();

      if ($preferred.length) {
        $preferred.first().trigger('click');
        return;
      }

      var $active = $visible.filter('.active');
      if ($active.length) {
        $active.first().trigger('click');
      } else if ($visible.length) {
        $visible.first().trigger('click');
      }
    }

    function getSm2026ToggleSize($toggleItem) {
      var size = $toggleItem.attr('data-option-size');
      if (size) {
        return size;
      }
      return $toggleItem.hasClass('mini') ? 'Mini' : 'Standard';
    }

    function applySm2026SizeFilter($item, size, triggerClick) {
      applySm2026VariantVisibility($item, triggerClick);
    }

    $(document).on('click', '.sm2026-bigproduct-cards .toggle-product-size .toggle-product-size-item', function () {
      var $toggle = $(this);
      var $item = $toggle.closest('.item');
      $toggle.addClass('active').siblings().removeClass('active');
      applySm2026VariantVisibility($item, true);
    });

    $(document).on('click', '.sm2026-bigproduct-cards .charger-port-items-wrapper .charger-port-item', function () {
      var $portItem = $(this);
      var $item = $portItem.closest('.item');
      $portItem.addClass('active').siblings().removeClass('active');
      applySm2026VariantVisibility($item, true);
    });

    $('.sm2026-bigproduct-cards .item').each(function () {
      var $item = $(this);
      applySm2026VariantVisibility($item, false);

      var variantIndex = Number($item.attr('data-variant-index'));
      var $variantItem = variantIndex > 1
        ? $item.find('.color_list .variant-item').eq(variantIndex - 1)
        : $item.find('.color_list .variant-item').filter(function () {
            return $(this).css('display') !== 'none';
          }).first();

      if (!$variantItem.length) {
        return;
      }

      if ($variantItem.attr('data-option-size') === 'Mini' && $item.find('.toggle-product-size .toggle-product-size-item.mini').length) {
        $item.find('.toggle-product-size .toggle-product-size-item.mini').trigger('click');
        return;
      }

      if ($variantItem.css('display') === 'none') {
        var size = $variantItem.attr('data-option-size') || 'Standard';
        $item.find('.toggle-product-size .toggle-product-size-item').each(function () {
          if (getSm2026ToggleSize($(this)) === size) {
            $(this).trigger('click');
            return false;
          }
        });
        return;
      }

      $variantItem.trigger('click');
      updateSm2026VariantPrice($item);
      updateSm2026GiftImage($item);
    });

    function getSm2026ActiveProductData($item) {
      return $item.find('.variant-wrapper.active .product-data-div').attr('data-product-data')
        || $item.find('.color_list .variant-item.active .product-data-div').attr('data-product-data')
        || $item.find('.variant-wrapper .product-data-div').first().attr('data-product-data');
    }

    // 曝光埋点：仅 spring-sale-pre-product 大产品卡
    var preProductSection = document.querySelector('.spring-sale-pre-product');
    var preProductCardsRoot = preProductSection
      ? preProductSection.querySelector('.sm2026-bigproduct-cards')
      : null;

    if (preProductCardsRoot) {
      var preheatItemListId = preProductSection.getAttribute('data-ga-item-list') || 'top_sales';
      var record_export_collection = new Set();
      var time_interval_home_product_list = -1;
      var home_product_list_attr = [];

      function home_product_ga4_deal_list(collection) {
        clearInterval(time_interval_home_product_list);
        var groupedItems = {};
        var groupKey = preheatItemListId.split(' ').join('');

        collection.forEach(function (element) {
          var collection_item = element.split('::');
          var itemName = '';
          var itemVariant = '';
          var itemCategory = '';
          var itemCategory2 = 'Standard';

          if (product_handle_map.has(collection_item[0])) {
            itemName = product_handle_valueMap[collection_item[0]][0];
            itemVariant = product_handle_valueMap[collection_item[0]][1];
            itemCategory = product_handle_valueMap[collection_item[0]][2];
            itemCategory2 = product_handle_valueMap[collection_item[0]][3];
          } else {
            itemName = collection_item[8] || collection_item[3] || '';
            itemVariant = collection_item[1] || '';
          }

          var arr_item = {
            item_id: collection_item[0],
            item_name: itemName,
            index: Number(collection_item[2]) + 1,
            item_list_id: preheatItemListId,
            item_list_name: preheatItemListId,
            item_category: itemCategory,
            item_category2: itemCategory2,
            item_category3: (collection_item[6] || '').replace('Default Title', 'none'),
            item_variant: itemVariant,
            item_brand: 'SHOKZ',
            price: Number(collection_item[9].split('$').join('').split(',').join('.')),
            quantity: Number(collection_item[10]),
            currency: 'JPY'
          };

          if (!groupedItems[groupKey]) {
            groupedItems[groupKey] = [];
          }
          groupedItems[groupKey].push(arr_item);
        });

        Object.keys(groupedItems).forEach(function (itemListId) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event_parameters: null });
          window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'view_item_list',
            event_parameters: {
              currency: 'JPY',
              item_list_id: preheatItemListId,
              item_list_name: preheatItemListId,
              items: groupedItems[itemListId]
            }
          });
        });
      }

      var observer_home_product = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var $item = $(entry.target);
          var product_item2 = getSm2026ActiveProductData($item);
          if (!product_item2) return;

          var product_item = product_item2.split('::');
          var product_item_record = product_item[3] || product_item[1] || product_item[0];

          if (!record_export_collection.has(product_item_record)) {
            record_export_collection.add(product_item_record);
            home_product_list_attr.push(product_item2);
            clearInterval(time_interval_home_product_list);
            time_interval_home_product_list = setInterval(function () {
              clearInterval(time_interval_home_product_list);
              home_product_ga4_deal_list(home_product_list_attr);
              home_product_list_attr = [];
            }, 3000);
          }

          observer_home_product.unobserve(entry.target);
        });
      });

      preProductCardsRoot.querySelectorAll('.item').forEach(function (element) {
        observer_home_product.observe(element);
      });
    }


    // 产品 GA4（select_item / add_to_cart）
    function page_product_ga4_deal(product_item, buttom_name, event_name, $item) {
      var itemName = '';
      var itemVariant = '';
      var itemCategory = '';
      var itemCategory2 = 'Standard';

      if (typeof product_handle_map !== 'undefined' && product_handle_map.has(product_item[0])) {
        itemName = product_handle_valueMap[product_item[0]][0];
        itemVariant = product_handle_valueMap[product_item[0]][1];
        itemCategory = product_handle_valueMap[product_item[0]][2];
        itemCategory2 = product_handle_valueMap[product_item[0]][3];
      } else {
        itemName = product_item[1] || product_item[8] || '';
      }

      var $activeVariant = sm2026GetActiveColorItem($item);
      if ($activeVariant.length) {
        var optionSize = $activeVariant.attr('data-option-size');
        if (optionSize) {
          itemCategory2 = optionSize;
        }
      }

      var itemListId = sm2026GetItemListId($item, product_item);
      var listIndex = sm2026GetCardListIndex($item);
      if (!($item && $item.length)) {
        listIndex = Number(product_item[2]) + 1;
      }

      var itemCategory3 = String(product_item[6] || '').replace('Default Title', 'none');
      if ($activeVariant.length) {
        var colorLabel = $activeVariant.attr('data-tag') || $activeVariant.attr('data-option1');
        if (colorLabel) {
          itemCategory3 = colorLabel;
        }
      }

      var price = sm2026ParseMoneyAmount(product_item[9]);
      var quantity = Number(product_item[10]) || 1;
      var discount = event_name === 'add_to_cart' ? sm2026GetCardDiscount($item, price) : 0;

      var gaItem = {
        item_id: product_item[0],
        item_name: itemName,
        index: listIndex,
        item_list_id: itemListId,
        item_list_name: itemListId,
        item_category: itemCategory,
        item_category2: itemCategory2,
        item_category3: itemCategory3,
        item_variant: itemVariant,
        item_brand: 'SHOKZ',
        price: price,
        quantity: quantity,
        currency: 'JPY'
      };

      if (event_name === 'add_to_cart') {
        gaItem.discount = discount;
      }

      var eventParameters = {
        item_list_id: itemListId,
        item_list_name: itemListId,
        currency: 'JPY',
        items: [gaItem]
      };

      if (buttom_name) {
        eventParameters.button_name = buttom_name;
      }

      if (event_name === 'add_to_cart') {
        eventParameters.value = price * quantity;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: event_name,
        event_parameters: eventParameters
      });
    }

    function sm2026GetProductLinkItemData($item) {
      var $productLink = $item.find('.porduct-link');
      if (!$productLink.length) return null;

      var product_item = $productLink.parent().find('.product-data-div').attr('data-product-data');
      return product_item ? product_item.split('::') : null;
    }

    function sm2026HandleProductLinkSelect($item) {
      var product_item = sm2026GetProductLinkItemData($item);
      if (!product_item) return;

      page_product_ga4_deal(product_item, 'Product Link Button', 'select_item', $item);
    }

    function sm2026NavigateToProductLink($item) {
      var href = $item.find('.porduct-link').attr('href');
      if (href) {
        window.open(href, '_blank', 'noopener,noreferrer');
      }
    }

    $('.sm2026-bigproduct-cards .item .porduct-link').on('click', function () {
      sm2026HandleProductLinkSelect($(this).closest('.item'));
    });

    $('.sm2026-bigproduct-cards .item .variant-img').on('click', function () {
      var $item = $(this).closest('.item');
      sm2026HandleProductLinkSelect($item);
      sm2026NavigateToProductLink($item);
    });

    $('.sm2026-bigproduct-cards .item .name').on('click', function () {
      var $item = $(this).closest('.item');
      sm2026HandleProductLinkSelect($item);
      sm2026NavigateToProductLink($item);
    });

  });
